import { ObjectUtils } from './object.utils';

export class ArrayUtils {
  static uniqueObjects(arr: any[], compareKey: string): any[] {
    return Array.from(new Set(arr.map(a => a[compareKey])))
      .map(key => {
        return arr.filter(a => a[compareKey] === key).reduce((prev, curr) => {
          return {
            ...curr,
            quantity: prev.quantity + curr.quantity,
          };
        });
      });
  }

  static getNumberOfEachElements(arr: any[], objectKey: string): Record<string, number> {
    const counts: Record<string, number> = {};
    for (const item of arr) {
      const key: string = item[objectKey];
      counts[key] = (counts[key] || 0) + 1;
    }
    return counts;
  }

  static arrayOfNumbers(count: number): Array<number> {
    return Array.from(new Array(count), (_, i) => i + 1);
  }

  static searchForHighestPageHeader(elements: NodeListOf<HTMLHeadingElement> | null): HTMLHeadingElement | boolean {
    return elements !== null && elements.length > 0 ? elements[0] : false;
  }

  static sortByAttribute(values: any[], attribute: string, revert: boolean = false, time: boolean = false, numeric: boolean = false): Array<any> {
    const sorted: any[] = [...values].sort((a, b) => {
      let attrA: any = ObjectUtils.getObjectbyString(a, attribute) ?? '';
      let attrB: any = ObjectUtils.getObjectbyString(b, attribute) ?? '';

      if (numeric && typeof attrA === 'number' && typeof attrB === 'number') {
        return attrA - attrB;
      }

      if (time) {
        const dateA: number = new Date(attrA).getTime() || 0;
        const dateB: number = new Date(attrB).getTime() || 0;
        return dateA - dateB;
      }

      if (typeof attrA === 'number') {
        attrA = attrA.toString();
      }
      if (typeof attrB === 'number') {
        attrB = attrB.toString();
      }

      attrA = attrA.toUpperCase();
      attrB = attrB.toUpperCase();

      if (attrA < attrB) {
        return -1;
      }
      if (attrA > attrB) {
        return 1;
      }

      return 0;
    });

    if (revert) {
      sorted.reverse();
    }

    return sorted;
  }

  static removeDuplicates(listWithDuplicates: any[]): Array<any> {
    return listWithDuplicates.filter((element, index) => {
      const elementClone: string = JSON.stringify(element);
      return index === listWithDuplicates.findIndex(obj => {
        return JSON.stringify(obj) === elementClone;
      });
    });
  }

  static readonly concatArrays: (...arrays: any[]) => any[] = (...arrays: any[]) => arrays.filter(Array.isArray).flat();
}
